import http from 'services/http';

export const checkMenuAvailability = ({ dateTime, idOrSlug }) =>
  http.get(`v1/restaurants/${idOrSlug}/availability/${dateTime ? `?scheduled_datetime=${new Date(dateTime).toISOString()}`: ''}`);
